import React from "react";

import {
  makeStyles,
  createStyles,
  Chip,
  Theme,
  Badge,
} from "@material-ui/core";
import { AddCircle, Cancel } from "@material-ui/icons";
import clsx from "clsx";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      // backgroundColorはPropsのclassNameでの上書きを前提とする
      backgroundColor: "",
      "&:hover": {
        backgroundColor: "",
      },
      "&:focus": {
        backgroundColor: "",
      },
      borderRadius: "6px",
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(0.5),
      marginLeft: theme.spacing(0.5),
    },
  })
);

interface Props {
  text: string;
  disabled?: boolean;
  deleting?: boolean;
  adding?: boolean;
  className?: string;
  onDelete?: () => void;
}

/** 同義語彙チップ */
export function SynonymChip(props: Props) {
  const classes = useStyles();

  const { text, disabled, deleting, adding, className, onDelete } = props;

  return (
    // 追加マーク
    <Badge
      variant="dot"
      color="primary"
      overlap="circle"
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      invisible={!adding}
    >
      <Chip
        label={text}
        size="small"
        className={clsx(classes.chip, className)}
        onDelete={onDelete}
        deleteIcon={deleting ? <AddCircle /> : <Cancel />}
        disabled={disabled}
      />
    </Badge>
  );
}
